import { render, staticRenderFns } from "./AddressFormSaved.vue?vue&type=template&id=234cd303&scoped=true&"
import script from "./AddressFormSaved.vue?vue&type=script&lang=js&"
export * from "./AddressFormSaved.vue?vue&type=script&lang=js&"
import style0 from "./AddressFormSaved.vue?vue&type=style&index=0&id=234cd303&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234cd303",
  null
  
)

export default component.exports